/**
 * Imports the necessary React components and libraries for a specific module.
 * @module
 * @requires React
 * @requires Card from "react-bootstrap"
 * @requires Tab from "react-bootstrap/Tab"
 * @requires Tabs from "react-bootstrap/Tabs"
 * @requires Link from "react-router-dom"
 * @requires useTranslation from "react-i18next"
 * @requires CSmartTable from "@coreui/react-pro"
 * @requires CustomToggleButton from "../../components/customToggleButton/customToggleButton"
 * @requires Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb"
 * @requires CustomButton from "../../components/customButton/customButton"
 * @requires ConfirmModal from "../../components/confirmModal/confirmModel"
 * @requires EmptyCell from "../../
 */
import DOMPurify from "dompurify";
import moment from "moment";
import React, { useState } from "react";
import { Card, Modal, Nav, Spinner } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import InQueueTabContainer from "./inQueueTab/inQueueTabContainer";
import TicketStatusTabContainer from "./ticketStatusTab/ticketStatusTabContainer";

import ConfirmModal from "../../../components/confirmModal/confirmModel";
import Breadcrumbs from "../../../components/customBreadcrumb/customBreadcrumb";
import CustomeShimer from "../../../components/customeShimer/customeShimer";
import AvatarImageWithFallback from "../../../components/avatarImageWithFallback/AvatarImageWithFallback";
import EventTableBookingDetailView from "./EventTableBookingDetailView";
import EventCatalogManagerAttach from "../../clubCatalog/EventCatalogManagerAttach";
import CustomToggleButton from "../../../components/customToggleButton/customToggleButton";
import { normalizeTicketOfflineSoldOut } from "../../../helpers/eventOfflineAssignment";

import { getCloudinaryMediaBaseUrl } from "../../../config/cloudinaryBase";
import { pickEventDisplayNumber } from "../../../helpers/eventDisplayNumber";
import { resolveCloudinaryImageSrc } from "../../../helpers/helper.service";
import Constant from "../../../util/constant";

import "./currentEventDetail.css";

const CurrentEventDetailComponent = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  /**
   * Constructs the Cloudinary URL by concatenating the environment variables
   * for the Cloudinary URL, name, and subfolder.
   * @returns The constructed Cloudinary URL.
   */
  const CLOUDINARY_URL = getCloudinaryMediaBaseUrl();

  const {
    placeHolderShimer,
    tableContainerRef,
    showEventDeleteModal,
    showEventCancelModal,
    showEventCloseModal,
    onEventDelete,
    onCancelEvent,
    onCloseEvent,
    closeEventDeletModal,
    closeEventCancelModal,
    closeEventCloseModal,
    openEventDeleteModal,
    openCancelEventModal,
    openCloseEventModal,
    state,
    pageTitle,
    onBackArrow,
    deleteLoader,
    eventstatusCancel,
    eventCancelLoader,
    eventCloseLoader,
    canCloseEvent,
    foundItem,
    exportToExcel,
    viewLayoutOpenModal,
    showLayoutModal,
    cancelLayoutModal,
    canDownloadEventSummary,
    eventSummaryDownloading,
    eventSummaryCheckingReadiness,
    onDownloadEventSummary,
    onCheckEventSummaryScannerStatus,
    eventsReadOnly,
    clubId,
    canManageSoldOutToggles,
    onTicketSoldOutToggle,
    onTableAvailabilityChange,
    onTableChannelSoldOutChange,
    toggleSavingKey,
    isClubManager,
    isAdmin,
    onCatalogAttachSaved,
  } = props;
  const [pendingTicketSoldOutChange, setPendingTicketSoldOutChange] =
    useState(null);
  const stateEventData = foundItem || state?.item;

  const requestTicketSoldOutToggle = (ticket, field, checked) => {
    const currentValue =
      field === "offlineSoldOut"
        ? normalizeTicketOfflineSoldOut(ticket)
        : Boolean(ticket.soldout);
    if (currentValue === checked) return;
    setPendingTicketSoldOutChange({
      ticket,
      field,
      checked,
      ticketType: ticket?.tickettype || t("TICKET_TYPE"),
    });
  };

  const closeTicketSoldOutConfirm = () => setPendingTicketSoldOutChange(null);

  const confirmTicketSoldOutToggle = () => {
    if (!pendingTicketSoldOutChange) return;
    onTicketSoldOutToggle?.(
      pendingTicketSoldOutChange.ticket,
      pendingTicketSoldOutChange.field,
      pendingTicketSoldOutChange.checked
    );
    setPendingTicketSoldOutChange(null);
  };

  const pendingSoldOutChannelLabel =
    pendingTicketSoldOutChange?.field === "offlineSoldOut"
      ? t("TICKET_OFFLINE_SO_SHORT")
      : t("TICKET_ONLINE_SO_SHORT");
  if (tableContainerRef.current) {
    const emptyRows =
      tableContainerRef.current.getElementsByClassName("emptyRow");
    if (emptyRows) {
    }
  }
  const sanitizedHtml = DOMPurify.sanitize(stateEventData?.aboutevent);
  const termsHtmlConvert = DOMPurify.sanitize(stateEventData?.terms);
  const eventDate =
    moment(stateEventData?.startdatetime).format("DD MMM YY") +
    "-" +
    moment(stateEventData?.enddatetime).format("DD MMM YY");
  const eventDisplayNumber = pickEventDisplayNumber(stateEventData);
  const eventTitleText =
    stateEventData?.title != null && String(stateEventData.title).trim() !== ""
      ? String(stateEventData.title).trim()
      : "—";
  return (
    <>
      <React.Fragment>
        <div className="pageContent curruntEventDetails">
          <Breadcrumbs
            innerPagetitle={t("VIEW_EVENT")}
            breadcrumbItem={t("VIEW_EVENT")}
            pageTitle={pageTitle}
            BreadcrumbInner={true}
            BreadcrumbmainTitle={true}
            backArrow={true}
            onBackArrow={onBackArrow}
          />
          <div
            className="mainCurruntEvent"
          // style={{
          //   height:
          //     dimensions.width < 1279 &&
          //     dimensions.height - breadcrumbHeight - 350,
          // }}
          >
            <Card className="curruntEventDetailPage">
              <Card.Body className="p-0">
                <div className="mainDetailsWrapper">
                  <div className="documentImage">
                    <>
                      {placeHolderShimer && <CustomeShimer />}
                      <img
                        src={resolveCloudinaryImageSrc(
                          stateEventData?.image,
                          CLOUDINARY_URL
                        )}
                        alt="Event-Img"
                      />
                    </>
                    <button
                      type="button"
                      onClick={viewLayoutOpenModal}
                      className="viewLayoutLinkStyle"
                    >
                      {t("VIEW_LAYOUT")}
                    </button>
                  </div>
                  <div className="documentContent">
                    <div className="titleDiv">
                      <div className="event-title-block">
                        <h1 className="mb-0">
                          {placeHolderShimer && <CustomeShimer />}
                          {eventTitleText}
                          {stateEventData?.is18Plus === true ? (
                            <span
                              className="badge bg-warning text-dark ms-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              18+
                            </span>
                          ) : null}
                        </h1>
                        {eventDisplayNumber ? (
                          <div
                            className="event-number-under-title"
                            style={{ color: "#ffffff" }}
                          >
                            {t("EVENT_NUMBER")}=#{eventDisplayNumber}
                          </div>
                        ) : null}
                      </div>
                      <div className="detailsBtnWrapper">
                        <div className="status">
                          {placeHolderShimer && <CustomeShimer />}
                          <span className="eventLabel">
                            {t("EVENT_STATUS")}
                          </span>
                          <span
                            className={
                              stateEventData?.eventstatus ===
                                Constant.GENERALKEYS.ONGOING
                                ? "onGoing tdWrapper"
                                : stateEventData?.eventstatus ===
                                  Constant.GENERALKEYS.UPCOMING
                                  ? "upComing tdWrapper"
                                  : stateEventData?.eventstatus ===
                                    Constant.GENERALKEYS.CANCEL
                                    ? "cancelled tdWrapper"
                                    : stateEventData?.eventstatus ===
                                      Constant.GENERALKEYS.COMPELETED
                                      ? "completed tdWrapper"
                                      : "tdWrapper cancelled"
                            }
                          >
                            {foundItem?.eventstatus ===
                              Constant.GENERALKEYS.CANCEL
                              ? "Cancelled"
                              : stateEventData?.eventstatus === "Cancel"
                                ? "Cancelled"
                                : stateEventData?.eventstatus}
                          </span>
                        </div>
                        {(!eventsReadOnly || canCloseEvent) && (
                          <div className="documentEditWrapperButton">
                            {!eventsReadOnly && (
                              <>
                                {placeHolderShimer && <CustomeShimer />}
                                <button
                                  className={
                                    foundItem?.eventstatus ===
                                      Constant.GENERALKEYS.CANCEL ||
                                    stateEventData?.eventstatus ===
                                      Constant.GENERALKEYS.CANCEL ||
                                    stateEventData?.eventstatus ===
                                      Constant.GENERALKEYS.COMPELETED
                                      ? "disableBtn ditButtton"
                                      : "ditButtton"
                                  }
                                  onClick={(e) => {
                                    if (
                                      stateEventData?.eventstatus ===
                                        Constant.GENERALKEYS.CANCEL ||
                                      stateEventData?.eventstatus ===
                                        Constant.GENERALKEYS.COMPELETED ||
                                      foundItem?.eventstatus ===
                                        Constant.GENERALKEYS.CANCEL
                                    ) {
                                    } else {
                                      navigate("/events-list/edit-event", {
                                        state: state,
                                      });
                                    }
                                  }}
                                >
                                  <i
                                    className="bx bxs-pencil font-size-24"
                                    id="deletetooltip"
                                  ></i>
                                </button>
                                <button
                                  className="Delete-Buttton"
                                  onClick={openEventDeleteModal}
                                >
                                  <i
                                    className="bx bxs-trash font-size-24"
                                    id="deletetooltip"
                                  ></i>
                                </button>
                                <button
                                  color="primary"
                                  className={
                                    eventstatusCancel === false &&
                                    state?.event !== "past"
                                      ? "btn-block btn btn-primary borderButton"
                                      : "btn-block btn btn-primary borderButton hide"
                                  }
                                  onClick={openCancelEventModal}
                                >
                                  <i className="bx bx-x"></i>
                                  {t("CANCEL_EVENT")}
                                </button>
                              </>
                            )}
                            {canCloseEvent ? (
                              <button
                                type="button"
                                color="primary"
                                className="btn-block btn btn-primary borderButton"
                                onClick={openCloseEventModal}
                              >
                                <i className="bx bx-check-circle"></i>
                                {t("CLOSE_EVENT")}
                              </button>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="eventTypePaymentDetails">
                      <div className="eventDetailsStyle">
                        <div className="detailContentWrapper firstcard">
                          <div className="detailContent">
                            {placeHolderShimer && <CustomeShimer />}
                            <span className="label">
                              {" "}
                              {t("EVENT_START_TIME")}
                            </span>
                            <div className="detailData">
                              {moment(stateEventData?.startdatetime).format(
                                "DD MMM YY, h:mm A"
                              )}
                            </div>
                          </div>
                          <div className="detailContent">
                            {placeHolderShimer && <CustomeShimer />}
                            <span className="label">{t("EVENT_END_TIME")}</span>
                            <div className="detailData">
                              {moment(stateEventData?.enddatetime).format(
                                "DD MMM YY, h:mm A"
                              )}
                            </div>
                          </div>
                          <div className="detailContent">
                            {placeHolderShimer && <CustomeShimer />}
                            <span className="label">
                              {t("EVENT_ORGANISER")}
                            </span>
                            <div className="detailData">
                              {stateEventData?.organizer?.map((org, idx) => (
                                <React.Fragment
                                  key={org?._id ?? org?.email ?? `org-${idx}`}
                                >
                                  <AvatarImageWithFallback
                                    src={resolveCloudinaryImageSrc(
                                      org?.image,
                                      CLOUDINARY_URL
                                    )}
                                    alt={org?.fullname || ""}
                                    width={20}
                                    height={20}
                                  />
                                  <p>{org?.fullname}</p>
                                </React.Fragment>
                              ))}
                            </div>
                          </div>
                          {!eventsReadOnly && (
                            <div className="detailContent">
                              {placeHolderShimer && <CustomeShimer />}
                              <span className="label">{t("BOOKING_%")}</span>
                              <div className="detailData">
                                {stateEventData?.bookingpercentage}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="detailContentWrapper secondCard">
                          {placeHolderShimer && <CustomeShimer />}
                          <div className="detailContent">
                            <span className="label">{t("LOCATION")}</span>
                            <div className="detailData">
                              {stateEventData?.location}
                            </div>
                          </div>
                          <div className="detailContent">
                            <span className="label">{t("LANGUAGE")}</span>
                            <div className="labelWraper">
                              <div className="detailDataRowStyle">
                                {stateEventData?.languageList?.map((item) => {
                                  return (
                                    <>
                                      <div className="detailData blackLabel">
                                        {item?.titleenglish}
                                      </div>
                                    </>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                          <div className="detailContent">
                            <span className="label">{t("GENERES")}</span>
                            <div className="labelWraper">
                              <div className="detailDataRowStyle">
                                {stateEventData?.genre?.map((item) => {
                                  return (
                                    <>
                                      <div className="detailData blackLabel">
                                        {item?.title}
                                      </div>
                                    </>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                          <div className="detailContent">
                            <span className="label">{t("CATEGORY")}</span>
                            <div className="labelWraper">
                              {stateEventData?.category?.map((item) => {
                                return (
                                  <>
                                    <div className="detailData blackLabel">
                                      {item?.title}
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                          <div className="detailContent">
                            <span className="label">{t("ARTIST")}</span>
                            <div className="labelWraper">
                              {stateEventData?.artistsDetails?.map((item) => {
                                return (
                                  <>
                                    <div className="detailData blackLabel">
                                      <img
                                        className="artistProfile"
                                        width={32}
                                        height={24}
                                        src={resolveCloudinaryImageSrc(
                                          item?.image,
                                          CLOUDINARY_URL
                                        )}
                                        alt=""
                                      />
                                      <p>{item?.name}</p>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                        <div className="detailContentWrapper thirdCard">
                          {placeHolderShimer && <CustomeShimer />}
                          <div className="detailContent">
                            <span className="label">{t("ABOUT")}</span>
                            <div className="detailData">
                              {/* <span>{stateEventData?.aboutevent?.replace(/(<([^>]+)>)/gi, "")}</span> */}
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: sanitizedHtml,
                                }}
                              />
                            </div>
                          </div>
                          <div className="detailContent">
                            <span className="label">{t("TERMS")}</span>
                            <div className="labelWraper">
                              <div className="detailData">
                                {/* <span>{stateEventData?.terms?.replace(/(<([^>]+)>)/gi, "")}</span> */}
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: termsHtmlConvert,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`typePaymentTableStyle${
                          canManageSoldOutToggles
                            ? " event-detail-ticket-table--manager"
                            : ""
                        }`}
                      >
                        <div className="viewTableStyle">
                          <div className="tableHeadRowStyle">
                            <div className="headTitleStyle">
                              {t("TICKET_TYPE")}
                            </div>
                            <div className="headTitleStyle">{t("PRICE")}</div>
                            <div className="headTitleStyle">
                              {t("TOTAL_TICKETS")}
                            </div>
                            <div className="headTitleStyle">
                              {t("TICKET_DESCRIPTION")}
                            </div>
                            <div className="headTitleStyle">
                              {t("TICKET_SOLD")}
                            </div>
                            {canManageSoldOutToggles ? (
                              <>
                                <div className="headTitleStyle event-detail-so-head">
                                  {t("TICKET_ONLINE_SO_SHORT")}
                                </div>
                                <div className="headTitleStyle event-detail-so-head">
                                  {t("TICKET_OFFLINE_SO_SHORT")}
                                </div>
                              </>
                            ) : null}
                          </div>

                          <div className="scrollViewStyle">
                            {foundItem?.tickets?.map((item, index) => {
                              const ticketId = item?._id ?? item?.id ?? index;
                              const onlineKey = `ticket:${ticketId}:soldout`;
                              const offlineKey = `ticket:${ticketId}:offlineSoldOut`;
                              return (
                              <div className="tbodyRowStyle" key={ticketId}>
                                <div className="tbodyTitleStyle">
                                  {item.tickettype}
                                </div>
                                <div className="tbodyTitleStyle">
                                  {item.ticketprice}
                                </div>
                                <div className="tbodyTitleStyle">
                                  {item.totaltickets}
                                </div>
                                <div className="tbodyTitleStyle">
                                  {item?.categorydesc}
                                </div>
                                <div className="tbodyTitleStyle">
                                  {item.ticketssold}{" "}
                                  {item.soldout ? (
                                    <span className="soldOutBtnStyle">
                                      Sold Out
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                {canManageSoldOutToggles ? (
                                  <>
                                    <div className="tbodyTitleStyle event-detail-soldout-toggle">
                                      <CustomToggleButton
                                        id={`ticket-online-${ticketId}`}
                                        checked={Boolean(item.soldout)}
                                        disabled={toggleSavingKey === onlineKey}
                                        onCheckChange={(checked) =>
                                          requestTicketSoldOutToggle(
                                            item,
                                            "soldout",
                                            checked
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="tbodyTitleStyle event-detail-soldout-toggle">
                                      <CustomToggleButton
                                        id={`ticket-offline-${ticketId}`}
                                        checked={normalizeTicketOfflineSoldOut(
                                          item
                                        )}
                                        disabled={
                                          toggleSavingKey === offlineKey
                                        }
                                        onCheckChange={(checked) =>
                                          requestTicketSoldOutToggle(
                                            item,
                                            "offlineSoldOut",
                                            checked
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                ) : null}
                              </div>
                            );
                            })}
                          </div>
                        </div>
                      </div>
                      {eventsReadOnly ? (
                        <EventTableBookingDetailView
                          eventItem={stateEventData}
                          clubId={clubId}
                          canManageToggles={canManageSoldOutToggles}
                          onTableAvailabilityChange={onTableAvailabilityChange}
                          onTableChannelSoldOutChange={
                            onTableChannelSoldOutChange
                          }
                          toggleSavingKey={toggleSavingKey}
                        />
                      ) : null}
                      {isClubManager ? (
                        <EventCatalogManagerAttach
                          eventItem={stateEventData}
                          clubId={clubId}
                          onSaved={onCatalogAttachSaved}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
            {canDownloadEventSummary && !eventsReadOnly ? (
              <Card className="mb-3 event-summary-reports-card">
                <Card.Body className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <h5 className="mb-1">{t("EVENT_SUMMARY_REPORTS_SECTION")}</h5>
                  </div>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="exportBtnStyle"
                      onClick={onCheckEventSummaryScannerStatus}
                      disabled={
                        eventSummaryDownloading || eventSummaryCheckingReadiness
                      }
                    >
                      {eventSummaryCheckingReadiness ? (
                        <>
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          {t("EVENT_SUMMARY_CHECKING_SCANNERS")}
                        </>
                      ) : (
                        <>
                          <i className="bx bx-radar"></i>{" "}
                          {t("EVENT_SUMMARY_CHECK_SCANNER_STATUS")}
                        </>
                      )}
                    </button>
                    <button
                      type="button"
                      className="exportBtnStyle"
                      onClick={onDownloadEventSummary}
                      disabled={
                        eventSummaryDownloading || eventSummaryCheckingReadiness
                      }
                    >
                      {eventSummaryDownloading ? (
                        <>
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          {t("CLUB_SALES_EVENT_SUMMARY_DOWNLOADING")}
                        </>
                      ) : (
                        <>
                          <i className="bx bx-download"></i>{" "}
                          {t("CLUB_SALES_EVENT_SUMMARY_DOWNLOAD")}
                        </>
                      )}
                    </button>
                  </div>
                </Card.Body>
              </Card>
            ) : null}
            {(!eventsReadOnly || isClubManager) && (
            <Card className="mb-0 cardMain">
              <div className="listTabStyle">
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="ticketStatus"
                >
                  <Nav variant="pills" className="flex-row mb-3">
                    <Nav.Item>
                      <Nav.Link eventKey="ticketStatus">
                        {t("TICKET_STATUS")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="inQueue">{t("IN_QUEUE")}</Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content>
                    <Tab.Pane eventKey="ticketStatus">
                      <button
                        className="exportBtnStyle"
                        type="button"
                        onClick={() =>
                          exportToExcel(
                            `${stateEventData?.title}-(${eventDate})-Booked_Tickets`
                          )
                        }
                      >
                        <i className="bx bx-export"></i>{" "}
                        {t("EXPORT_BOOKED_TICKET_DATA")}
                      </button>
                      <TicketStatusTabContainer data={state?.item} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="inQueue">
                      {/* <button className='exportBtnStyle'>{t('EXPORT_CSV')}</button> */}
                      <InQueueTabContainer data={state?.item} />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </Card>
            )}
          </div>
        </div>
      </React.Fragment>

      <ConfirmModal
        modalTitle={t("DELETE")}
        modalDescription={t(
          "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_EVENT_FROM_THE_LIST"
        )}
        isUnderline={false}
        showModal={showEventDeleteModal}
        leftBtnTitle={t("YES_DELETE")}
        isModelIcon={true}
        iconColor={"mdi mdi-delete-outline "}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="borderButton"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onEventDelete}
        rightButtonClick={closeEventDeletModal}
        loaderButtonShow={deleteLoader}
      />

      <ConfirmModal
        modalTitle={t("CANCEL_EVENT")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_EVENT")}
        noteText={t(
          "PLEASE_NOTE_THE_AMOUNT_FOR_TEH_TICKETS_BOUGHT_BY_THE_USERS_WILL_BE_REFUNDED_AFTER_15_DAYS"
        )}
        isUnderline={false}
        note={true}
        className="cancelEvent"
        showModal={showEventCancelModal}
        leftBtnTitle={t("YES_CONFIRM")}
        isModelIcon={true}
        iconColor={"bx bx-x"}
        iconCricle={"iconCricleCancel"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="borderButton"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onCancelEvent}
        rightButtonClick={closeEventCancelModal}
        loaderButtonShow={eventCancelLoader}
      />

      <ConfirmModal
        modalTitle={t("CLOSE_EVENT")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_CLOSE_THIS_EVENT")}
        noteText={t("CLOSE_EVENT_NOTE")}
        isUnderline={false}
        note={true}
        className="cancelEvent"
        showModal={showEventCloseModal}
        leftBtnTitle={t("YES_CONFIRM")}
        isModelIcon={true}
        iconColor={"bx bx-check-circle"}
        iconCricle={"iconCricleCancel"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="borderButton"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onCloseEvent}
        rightButtonClick={closeEventCloseModal}
        loaderButtonShow={eventCloseLoader}
      />

      <ConfirmModal
        modalTitle={t("EVENT_TICKET_CONFIRM_SOLD_OUT_TITLE")}
        modalDescription={t("EVENT_TICKET_CONFIRM_SOLD_OUT_CHANGE", {
          channel: pendingSoldOutChannelLabel,
          ticketType: pendingTicketSoldOutChange?.ticketType ?? "",
        })}
        isUnderline={false}
        showModal={Boolean(pendingTicketSoldOutChange)}
        leftBtnTitle={t("YES_CONFIRM")}
        isModelIcon={true}
        iconColor="mdi mdi-help-circle-outline"
        iconCricle="iconCricleCancel"
        leftBtnClass="ok_Btn"
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="borderButton"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={confirmTicketSoldOutToggle}
        rightButtonClick={closeTicketSoldOutConfirm}
        onHide={closeTicketSoldOutConfirm}
        loaderButtonShow={
          pendingTicketSoldOutChange
            ? toggleSavingKey ===
                `ticket:${
                  pendingTicketSoldOutChange.ticket?._id ??
                  pendingTicketSoldOutChange.ticket?.id
                }:${pendingTicketSoldOutChange.field}`
            : false
        }
      />

      <Modal
        className={"confirmModal layoutImageModal"}
        show={showLayoutModal}
        onHide={cancelLayoutModal}
        centered
      >
        <div className="headerRowStyle">
          <div className="modalTitleStyle">{t("VIEW_LAYOUT")}</div>
          <button onClick={cancelLayoutModal} className="closeBtnStyle">
            <i className="mdi mdi-window-close"></i>
          </button>
        </div>
        <div className="layoutImageTextRowStyle">
          <div className="layoutImage">
            {" "}
            <img
              src={resolveCloudinaryImageSrc(
                stateEventData?.layoutimage,
                CLOUDINARY_URL
              )}
              alt="Event-Img"
            />
          </div>
          <div className="layoutTextStyle">{stateEventData?.layoutdesc}</div>
        </div>
      </Modal>
    </>
  );
};

export default CurrentEventDetailComponent;
